export default __webpack_public_path__ + "static/media/facebook.a3b518d5.png";